import { StatelessComponent } from 'react'
import * as styles from 'components/features/pfm/ProgressBar/ProgressBar.css'

export type ProgressBarProps = {
  progress: number // in %
}
/**
 * @deprecated use features/ProgressBar
 */
const ProgressBar: StatelessComponent<ProgressBarProps> = (props) => {
  const { progress } = props
  const transform = `translateX(${ progress }%)`

  return (
    <div className={ styles.progressBar }>
      <div
        className={ styles.filling }
        style={{ transform }}
      />
    </div>
  )
}

export default ProgressBar
